module.exports = __webpack_public_path__ + "media/src/assets/images/about-pic2-f98f94d159162dafd5d1bb85ae2fa5e0.png";